import { parseHtml } from '@healthhub/react-ui';
import { Typography } from 'antd';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { A11y, Keyboard, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { MaxWidthContainer } from '@shared/components';
import { useGetHomePageTrendingArticlesQuery } from '@shared/services/sitecore';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/keyboard';
import 'swiper/css/a11y';

const { Text, Title } = Typography;

const LatestTrendingArticles = () => {
  const { t } = useTranslation('home');
  const { data } = useGetHomePageTrendingArticlesQuery();

  if ((data?.wellBeingLifeStyle.length ?? 0) === 0) {
    return null;
  }

  return (
    <div className="max-w-screen flex w-full justify-center overflow-hidden bg-white px-6 pb-10 pt-6 lg:px-18 lg:pt-15">
      <MaxWidthContainer className="flex flex-col gap-3">
        <Title className="my-0 text-2xl font-semibold text-primary-blue-grey-4 lg:text-3.5xl" level={2}>
          {t('latestTrendingContent')}
        </Title>
        <Swiper
          breakpoints={{
            769: {
              slidesPerView: 2.5,
            },

            992: {
              slidesPerView: 4,
            },
          }}
          className="size-full overflow-visible"
          grabCursor
          keyboard={{
            enabled: true,
          }}
          modules={[Keyboard, Navigation, A11y]}
          slidesPerView={1.5}
          spaceBetween={24}
        >
          {data?.wellBeingLifeStyle.map(({ description, image, link, title }) => (
            <SwiperSlide key={title}>
              <a
                className="block h-full rounded-lg bg-white shadow-[0px_4px_12px_0px_rgba(0,0,0,0.12)]"
                href={link}
                rel="noreferrer"
                target="_blank"
              >
                <div className="relative h-44 w-full lg:h-52">
                  <div className="absolute top-0 z-sticky size-full rounded-t-lg border border-x-4 border-t-4 border-[#FFFFFF99]" />
                  <img
                    alt={title}
                    className="absolute top-0 size-full rounded-t-lg object-cover object-center"
                    src={image}
                  />
                </div>
                <div className="flex flex-col gap-2 p-4">
                  <Title className="m-0 line-clamp-2 text-xl font-semibold text-primary-blue-grey" level={3}>
                    {parseHtml(DOMPurify.sanitize(title))}
                  </Title>
                  <Text className="line-clamp-3 text-base text-functional-iron">
                    {parseHtml(DOMPurify.sanitize(description))}
                  </Text>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </MaxWidthContainer>
    </div>
  );
};

export default LatestTrendingArticles;
